import o from"../../../node_modules/styled-components/dist/styled-components.esm.js";import{defaultTheme as e}from"../../../theme/index.js";const t=o.footer`
  position: relative;
  padding: 8px 10px;
  border-top: 1px solid ${e.theme.colorVariables.borderAccent};
  margin: auto 0 0;
`;t.defaultProps=e;export{t as Footer};
